import { NavLink, Outlet, useLocation } from 'react-router-dom'

import { cn } from '@/lib/cn'
import { useWorkspace } from '@/lib/workspace'

const TABS = [
  { to: 'general', label: 'General' },
  { to: 'members', label: 'Members' },
  { to: 'labels', label: 'Labels' },
  { to: 'ai', label: 'AI' },
  { to: 'voice', label: 'Voice' },
  { to: 'notifications', label: 'Notifications' },
  { to: 'billing', label: 'Billing' },
  { to: 'account', label: 'Account' },
]

/** Shared chrome for every screen under `/{slug}/settings`. */
export default function SettingsLayout() {
  const workspace = useWorkspace()
  const location = useLocation()

  // Billing shows four plan cards side by side. Inside the 3xl column used by
  // every other settings screen they were about 165px wide whatever the
  // screen size, which squeezed the call to action until its label spilled
  // outside the button. A plan comparison needs the room; a members table
  // does not, so only this one tab gets it.
  const isWide = location.pathname.endsWith('/billing')

  return (
    <div className={cn('mx-auto px-6 py-10', isWide ? 'max-w-6xl' : 'max-w-3xl')}>
      <header className="mb-6">
        <h1 className="text-xl font-semibold tracking-tight">Settings</h1>
        <p className="mt-1 text-sm text-ink-500 dark:text-ink-400">{workspace.membership.name}</p>
      </header>

      {/* The rule lives on the wrapper so the tab strip can pull itself 1px down
          over it without that 1px becoming vertical overflow — which is what
          produces a stray scrollbar on systems that always show them. */}
      <div className="mb-8 border-b border-ink-200 dark:border-ink-800">
        <nav aria-label="Settings" className="-mb-px flex gap-1 overflow-x-auto">
          {TABS.map((tab) => (
            <NavLink
              key={tab.to}
              to={workspace.path(`/settings/${tab.to}`)}
              className={({ isActive }) =>
                cn(
                  'border-b-2 px-3 py-2 text-sm whitespace-nowrap transition',
                  isActive
                    ? 'border-brand-600 font-medium text-brand-700 dark:text-brand-300'
                    : 'border-transparent text-ink-500 hover:text-ink-900 dark:text-ink-400 dark:hover:text-ink-100',
                )
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </nav>
      </div>

      <Outlet />
    </div>
  )
}
